<div class="radm">
  <header class="radm-header">
    <h1>Referidos</h1>
    <span class="radm-switch" [class.on]="resumen?.activo">
      {{ resumen?.activo ? 'Programa encendido' : 'Programa apagado' }}
    </span>

    <button class="radm-config-btn" (click)="abrirAlta()">Nueva campaña</button>
    <button class="radm-config-btn" (click)="abrirConfig()">Configurar</button>
    <button class="radm-config-btn" (click)="mostrarAyuda = true">¿Cómo funciona?</button>
  </header>

  <!--
    La ayuda. Explica lo que el formulario no puede: por qué los cupos van en
    pares, qué queda congelado, y qué pasa al activar.
  -->
  <div class="radm-overlay" *ngIf="mostrarAyuda" (click)="mostrarAyuda = false">
    <div class="radm-modal ancho radm-ayuda" (click)="$event.stopPropagation()">
      <h2>Cómo funciona el programa de referidos</h2>

      <div class="radm-tabs">
        <button [class.on]="ayudaSeccion === 'programa'" (click)="ayudaSeccion = 'programa'">
          La configuración general
        </button>
        <button [class.on]="ayudaSeccion === 'campana'" (click)="ayudaSeccion = 'campana'">
          Crear una campaña
        </button>
      </div>

      <!-- ================================================ El programa ==== -->
      <ng-container *ngIf="ayudaSeccion === 'programa'">
        <p class="radm-destacado">
          La regla que ordena todo: <b>la campaña la trae el link de quien invita,
          nunca el invitado</b>. Cuando alguien se registra con la llave de otro,
          el sistema no se pregunta qué campaña le corresponde a esa persona: se
          pregunta qué campaña tiene asignada quien la invitó.
        </p>

        <h3>Qué es del programa entero</h3>
        <p>Sólo cuatro cosas viven en <b>Configurar</b>. Todo lo demás es de cada campaña.</p>
        <dl class="radm-def">
          <dt>El interruptor</dt>
          <dd>
            Apagado, no se registra ningún vínculo y no se paga nada, sin importar
            qué campañas estén activas. Quien entra por el link de alguien se da
            de alta como un cliente más.
            <b>Los invitados que se registren mientras está apagado no quedan
            vinculados a nadie: ese período no se recupera.</b>
          </dd>

          <dt>El techo del mes, por moneda</dt>
          <dd>
            El freno de mano. Alcanzado, se deja de pagar hasta el mes siguiente y
            avisa por Telegram — los vínculos <b>esperan, no se anulan</b>.
            Va uno por moneda y no uno solo: sumar dólares con bolívares exigiría
            una tasa, y eso ataría el control de gasto a la cotización del día.
          </dd>

          <dt>El umbral de doble control</dt>
          <dd>
            La bolsa a partir de la cual activar una campaña necesita
            <b>un segundo operador</b>: quien la crea no la activa.
            <b>0 significa «siempre», no «nunca»</b> — si el número no está
            cargado, la opción segura es pedir dos firmas.
          </dd>
        </dl>

        <h3>Qué pasa cuando alguien se registra con una llave</h3>
        <ol class="radm-pasos">
          <li>Verifica su correo y el sistema guarda la intención.</li>
          <li>
            Cuando termina el registro y el usuario existe de verdad, se resuelve
            su campaña: primero las asignadas de quien lo invitó, y si ninguna
            aplica, la global.
          </li>
          <li>
            <b>Ahí se congela todo</b>: monto, moneda, alcance, gatillo y pisos de
            carga, tal como estaban ese día. Nada de lo que pase después se los
            cambia — ni cerrar la campaña, ni subirle el monto, ni quitarle la
            asignación a quien lo invitó.
          </li>
          <li>
            Si no hay ninguna campaña que lo alcance, el vínculo se registra
            igual para poder medir el canal y <b>no paga nunca</b>. La pantalla lo
            dice: «no había promoción vigente».
          </li>
        </ol>

        <h3>Cuándo cobra cada uno</h3>
        <p>
          <b>El invitado siempre cobra al cargar</b> por primera vez, por encima
          del piso de su moneda. Eso no se configura: es regla del programa.
        </p>
        <p>
          <b>Quien invitó</b> cobra según el gatillo de su campaña, y además tiene
          que haber cargado él mismo dentro de la ventana de actividad. Esa
          segunda mitad es la que evita pagar por registros vacíos: veinte
          conocidos que se anotan y nunca cargan no valen nada.
        </p>
      </ng-container>

      <!-- ================================================ La campaña ===== -->
      <ng-container *ngIf="ayudaSeccion === 'campana'">
        <h3>Una campaña por país</h3>
        <dl class="radm-def">
          <dt>Chile · Venezuela</dt>
          <dd>
            Cada país tiene su campaña, con sus montos y sus condiciones, y
            <b>pueden estar activas las dos a la vez</b>. El país sale del
            documento: Chile (RUT) o Venezuela. Una campaña de Chile
            <b>no se le muestra ni se le paga</b> a un venezolano, y al revés:
            ni a quien invita ni a quien se registra. Otros documentos (CI,
            pasaporte, sin documento) no participan.
          </dd>
          <dt>Todos los países</dt>
          <dd>
            Alcanza a Chile y a Venezuela con las mismas condiciones.
            <b>No convive con campañas de país</b>: mientras haya una viva
            (activa, programada o pausada) no se puede crear ni activar una de
            país, y al revés.
          </dd>
          <dt>Qué no se cambia</dt>
          <dd>
            El país, la moneda y los montos no se tocan con la campaña viva: se
            cierra y se crea otra. Puede quedar sin fecha de fin.
          </dd>
        </dl>

        <h3>Los campos que más se malinterpretan</h3>
        <dl class="radm-def">
          <dt>Cupos</dt>
          <dd>
            Van <b>en pares</b>: el invitado y quien lo invitó son <b>1 cupo</b>,
            no 2. Cien cupos son cien invitados. El cupo se toma cuando el vínculo
            se cierra, no cuando se paga — si se tomara al pagar, dos invitados
            que cargan el mismo día podrían encontrarse con que quedaba uno solo.
          </dd>

          <dt>Cuota por referidor</dt>
          <dd>
            Cuántos pares le paga la campaña a <b>una misma persona</b>. Sin cuota,
            un solo referidor se lleva los cupos de la campaña en una tarde.
            Cuando alguien la agota, <b>no deja de cobrar</b>: cae a la global.
          </dd>

          <dt>Cargas mínimas</dt>
          <dd>
            No son un umbral secundario: son <b>la definición de «cargar»</b> para
            esa campaña. Conviene dejarlas parejas en valor entre las tres
            monedas, porque <b>la más baja es siempre la vía barata</b>: si el
            mínimo en USDT es 10 y el bono es 5, alguien deposita el mínimo, cobra
            y se va habiendo recuperado la mitad de lo que puso.
          </dd>

          <dt>Días de reserva</dt>
          <dd>
            Cuánto vive un bono prometido antes de vencer y <b>devolver el cupo y
            la cuota</b>. Corto vence bonos legítimos —hay gente que carga a las
            tres semanas—; largo congela presupuesto por gente que quizá no cargue
            nunca.
          </dd>

          <dt>Freno de velocidad</dt>
          <dd>
            Si se toma más de ese porcentaje de los cupos en esos minutos, la
            campaña <b>se pausa sola</b> y avisa. Cuenta cupos tomados, nunca
            intentos. Salir de una pausa por velocidad exige un segundo operador:
            si una sola persona pudiera reabrir lo que el freno detuvo, el freno
            sería un cartel.
          </dd>

          <dt>Cuándo cobra quien invita</dt>
          <dd>
            <b>Al cargar</b> es el default y lo más sano.
            <b>Al pasar el KYC</b> tiene la mejor conversión y es el único sin
            techo natural —el costo de una unidad pasa a ser el de completar un
            registro— así que exige bolsa chica, cuota de hasta 3 y freno de
            velocidad.
            <b>Al primer envío</b> es el mejor para la economía y el peor para la
            conversión, porque tarda.
          </dd>

          <dt>Puede acumular con un bono de bienvenida</dt>
          <dd>
            En «no» —el default— el invitado no puede además reclamar un bono de
            bienvenida del otro módulo. Importa justo acá: el invitado de
            referidos es exactamente el público de la bienvenida, así que en «sí»
            la misma alta paga dos veces.
          </dd>
        </dl>

        <h3>El ciclo de vida</h3>
        <ol class="radm-pasos">
          <li>
            <b>Borrador.</b> Nace apagada: no engancha a nadie ni compromete un
            peso. Acá se puede cambiar todo.
          </li>
          <li>
            <b>Activar.</b> Es el momento del doble control. Si la vigencia
            empieza en el futuro queda <i>programada</i> y arranca sola.
          </li>
          <li>
            <b>Pausar</b> detiene los vínculos nuevos y respeta los ya creados:
            mantienen su campaña y sus montos, y cobran si cumplen. Sus
            referidores pasan a la global mientras tanto.
          </li>
          <li>
            <b>Cerrar</b> termina el acuerdo y no se puede deshacer. Los bonos ya
            retenidos se respetan hasta que venza su reserva.
          </li>
        </ol>

        <p class="radm-destacado">
          Con la campaña ya viva <b>no se pueden cambiar la moneda ni los
          montos</b>. No es por los vínculos viejos —esos tienen lo suyo
          congelado— sino porque crear una campaña chica, hacerla aprobar y
          después subirle el monto sería la forma más limpia de sacar plata sin
          que ninguna revisión lo note. Para cambiar un monto se crea otra
          campaña.
        </p>
      </ng-container>

      <div class="radm-modal-acciones">
        <button class="radm-btn-cancelar" (click)="mostrarAyuda = false">Cerrar</button>
      </div>
    </div>
  </div>

  <!-- Configuración. Escribe en `parametros`: cada cambio queda en el log con
       el correo del operador y avisa al canal de Telegram. Acá viven sólo los
       controles del programa entero; lo demás es de cada campaña. -->
  <div class="radm-overlay" *ngIf="mostrarConfig && config" (click)="cerrarConfig()">
    <div class="radm-modal" (click)="$event.stopPropagation()">
      <h2>Configuración del programa</h2>

      <label class="radm-toggle">
        <input type="checkbox" [(ngModel)]="config.activo" />
        <span>
          <b>{{ config.activo ? 'Programa encendido' : 'Programa apagado' }}</b>
          <small>Apagado, el cliente no ve nada y no se paga ningún bono, sin importar qué campañas estén activas.</small>
        </span>
      </label>

      <div class="radm-grid">
        <label>
          <span>Techo del mes en USDT</span>
          <input type="number" min="0" [(ngModel)]="config.topeMensualUsdt" />
          <small>alcanzado, se deja de pagar y avisa</small>
        </label>
        <label>
          <span>Techo del mes en VES</span>
          <input type="number" min="0" [(ngModel)]="config.topeMensualVes" />
          <small>va aparte: sumarlos exigiría una tasa</small>
        </label>

        <label>
          <span>Doble control en USDT</span>
          <input type="number" min="0" [(ngModel)]="config.dobleControlUsdt" />
          <small>bolsa desde la cual activar exige otro operador. 0 = siempre</small>
        </label>
        <label>
          <span>Doble control en VES</span>
          <input type="number" min="0" [(ngModel)]="config.dobleControlVes" />
          <small>0 = siempre</small>
        </label>
      </div>

      <p class="radm-nota">
        Los montos, los pisos de carga, la ventana de actividad y las cuotas
        dejaron de vivir acá: ahora son de cada campaña, y por eso dos invitados
        del mismo día pueden cobrar distinto según de qué link vinieron.
      </p>

      <p class="radm-aviso" *ngIf="vaAEncender">
        Al encender, los bonos se empiezan a pagar. Los invitados que se registraron
        mientras estaba apagado no quedaron vinculados a nadie: ese período no se
        recupera.
      </p>

      <div class="radm-modal-acciones">
        <button class="radm-btn-guardar" [disabled]="!hayCambiosConfig || guardandoConfig"
                (click)="guardarConfig()">
          {{ guardandoConfig ? 'Guardando…' : 'Guardar' }}
        </button>
        <button class="radm-btn-cancelar" (click)="cerrarConfig()">Cancelar</button>
      </div>
    </div>
  </div>

  <!-- Alta de campaña. Nace en BORRADOR: no engancha vínculos ni compromete
       presupuesto hasta que alguien la active, y activarla puede exigir un
       segundo operador. -->
  <div class="radm-overlay" *ngIf="mostrarAlta" (click)="cerrarAlta()">
    <div class="radm-modal ancho" (click)="$event.stopPropagation()">
      <h2>{{ editando ? 'Editar ' + editando.codigo : 'Nueva campaña' }}</h2>

      <p class="radm-nota" *ngIf="editandoViva">
        Esta campaña ya está viva. La moneda y los montos no se pueden cambiar:
        subirle el monto a una campaña aprobada esquivaría el doble control.
        Los <b>vínculos ya creados mantienen lo que se les prometió</b>.
      </p>

      <div class="radm-grid">
        <label>
          <span>Nombre</span>
          <input type="text" [(ngModel)]="nueva.nombre" placeholder="Embajador Q4" />
          <small>interno, el que ves en el listado</small>
        </label>
        <label>
          <span>Código</span>
          <input type="text" [(ngModel)]="nueva.codigo" placeholder="EMBAJADOR" [disabled]="bloqueado('codigo')" />
          <small>único y para siempre. No viaja en el link</small>
        </label>

        <!-- Sin selector de tipo: las campañas de referidos son por país
             (GLOBAL). Las asignadas a clientes concretos no son parte del
             modelo y el backend ya no las crea. -->
        <label>
          <span>País</span>
          <select [(ngModel)]="nueva.alcanceCodigo" [disabled]="bloqueado('alcanceCodigo')">
            <option *ngFor="let a of opciones?.alcances" [value]="a.alcance">
              {{ a.nombre }}
            </option>
          </select>
          <small>a quién se le muestra y se le paga, de los dos lados. «Todos» no convive con las de país</small>
        </label>
        <label>
          <span>Moneda</span>
          <select [(ngModel)]="nueva.moneda" [disabled]="bloqueado('moneda')">
            <option *ngFor="let m of monedasDelAlcance" [value]="m">{{ m }}</option>
          </select>
          <small>sólo las que tienen cómo acreditarse</small>
        </label>

        <label>
          <span>Bono de quien invita</span>
          <input type="number" min="0" [(ngModel)]="nueva.montoReferidor" [disabled]="bloqueado('montoReferidor')" />
          <small>{{ nueva.moneda }}</small>
        </label>
        <label>
          <span>Bono del invitado</span>
          <input type="number" min="0" [(ngModel)]="nueva.montoReferido" [disabled]="bloqueado('montoReferido')" />
          <small>{{ nueva.moneda }}</small>
        </label>

        <label>
          <span>Cupos</span>
          <input type="number" min="1" [(ngModel)]="nueva.unidadesTotal" />
          <small>en pares: invitado + quien invita = 1</small>
        </label>
        <label>
          <span>Cuota por referidor</span>
          <input type="number" min="1" [(ngModel)]="nueva.cuotaPorReferidor" />
          <small>cuántos pares le paga a una misma persona</small>
        </label>

        <label>
          <span>Cuándo cobra quien invita</span>
          <select [(ngModel)]="nueva.gatilloReferidor">
            <option value="AL_FONDEAR">Cuando el invitado carga</option>
            <option value="AL_KYC">Cuando el invitado pasa el KYC</option>
            <option value="AL_PRIMER_ENVIO">Cuando el invitado hace su primer envío</option>
          </select>
          <small>el invitado siempre cobra al cargar</small>
        </label>
        <label>
          <span>Actividad de quien invita</span>
          <input type="number" min="0" max="365" [(ngModel)]="nueva.actividadReferidorDias" />
          <small>días en que tiene que haber cargado él. 0 = no se exige</small>
        </label>

        <label>
          <span>Carga mínima en CLP</span>
          <input type="number" min="0" [(ngModel)]="nueva.pisoFondeoClp" />
          <small>qué significa «cargar» en esta campaña</small>
        </label>
        <label>
          <span>Carga mínima en VES</span>
          <input type="number" min="0" [(ngModel)]="nueva.pisoFondeoVes" />
          <small>revisar contra la tasa</small>
        </label>
        <label>
          <span>Carga mínima en USDT</span>
          <input type="number" min="0" [(ngModel)]="nueva.pisoFondeoUsdt" />
          <small>parejo con los otros dos: el más bajo es la vía barata</small>
        </label>

        <label>
          <span>Vigencia desde</span>
          <input type="date" [(ngModel)]="nueva.vigenciaDesde" [disabled]="bloqueado('vigenciaDesde')" />
        </label>
        <label *ngIf="nueva.tipo === 'ASIGNADA'">
          <span>Vigencia hasta</span>
          <input type="date" [(ngModel)]="nueva.vigenciaHasta" />
          <small>sin fin, un acuerdo de temporada sigue pagando después</small>
        </label>

        <label>
          <span>Días de reserva</span>
          <input type="number" min="3" max="90" [(ngModel)]="nueva.reservaDias" />
          <small>cuánto vive un bono prometido antes de vencer</small>
        </label>
        <label>
          <span>Freno de velocidad</span>
          <input type="number" min="1" max="100" [(ngModel)]="nueva.pausaPct" />
          <small>% de cupos que pausa la campaña sola</small>
        </label>
        <label>
          <span>&hellip; en cuántos minutos</span>
          <input type="number" min="1" max="1440" [(ngModel)]="nueva.pausaMinutos" />
          <small>se cuentan cupos tomados, nunca intentos</small>
        </label>
      </div>

      <label class="radm-toggle">
        <input type="checkbox" [(ngModel)]="nueva.acumulaConBonos" />
        <span>
          <b>Puede acumular con un bono de bienvenida</b>
          <small>
            En «sí», la misma alta paga dos veces: el invitado de referidos es
            exactamente el público de la campaña de bienvenida.
          </small>
        </span>
      </label>

      <p class="radm-aviso" *ngIf="avisoKyc">{{ avisoKyc }}</p>

      <p class="radm-nota">
        Bolsa que compromete: <b>{{ bolsaEstimada | number: '1.0-2' }} {{ nueva.moneda }}</b>
        &middot; {{ nueva.unidadesTotal }} pares.
        Nace en BORRADOR y no paga nada hasta que se active.
      </p>

      <div class="radm-modal-acciones">
        <button class="radm-btn-guardar" [disabled]="guardandoAlta" (click)="guardarCampana()">
          {{ guardandoAlta
              ? 'Guardando…'
              : (editando ? 'Guardar cambios' : 'Crear campaña') }}
        </button>
        <button class="radm-btn-cancelar" (click)="cerrarAlta()">Cancelar</button>
      </div>
    </div>
  </div>

  <!-- Asignar referidores. La firma queda en la fila: dar recompensa mejorada a
       una persona es una decisión de plata.

       Va con radm-overlay-encima porque se abre desde adentro del detalle de
       campaña, que es otro overlay declarado más abajo en este mismo template.
       Con el mismo z-index gana el último del DOM, así que este quedaba tapado
       detrás del panel y el botón «Asignar» parecía no hacer nada. -->
  <div class="radm-overlay radm-overlay-encima" *ngIf="mostrarAsignar" (click)="cerrarAsignar()">
    <div class="radm-modal" (click)="$event.stopPropagation()">
      <h2>Asignar referidores</h2>
      <p class="radm-nota">
        Una llave o un correo por línea. Se los busca como los tengas a mano.
      </p>

      <label class="radm-textarea">
        <span>Llaves o correos</span>
        <textarea rows="6" [(ngModel)]="referidoresTexto"
                  placeholder="&#64;GUIDO2026&#10;yakelin&#64;mail.com"></textarea>
      </label>

      <div class="radm-grid">
        <label>
          <span>Cuota para estos</span>
          <input type="number" min="1" [(ngModel)]="cuotaAsignada" />
          <small>vacío = la de la campaña</small>
        </label>
      </div>

      <label class="radm-toggle">
        <input type="checkbox" [(ngModel)]="asignacionExclusiva" />
        <span>
          <b>Exclusiva</b>
          <small>cierra las otras asignaciones activas de esas personas</small>
        </span>
      </label>

      <div class="radm-modal-acciones">
        <button class="radm-btn-guardar" [disabled]="asignando || !referidoresTexto.trim()"
                (click)="asignar()">
          {{ asignando ? 'Asignando…' : 'Asignar' }}
        </button>
        <button class="radm-btn-cancelar" (click)="cerrarAsignar()">Cancelar</button>
      </div>
    </div>
  </div>

  <p class="radm-nota" *ngIf="resumen && !resumen.activo">
    Con <code>REFERIDOS_ACTIVO</code> en <code>NO</code> no se registran vínculos: quien entra por
    el link de alguien se da de alta como un cliente más. Los clientes sí pueden crear su usuario
    Aguacate, pero no ven el link para compartir.
  </p>

  <div class="radm-cargando" *ngIf="cargando">Cargando…</div>
  <div class="radm-error" *ngIf="error">{{ error }}</div>

  <ng-container *ngIf="!cargando && resumen">
    <!-- Los números -->
    <div class="radm-nums">
      <div class="radm-num">
        <span class="n">{{ totalResumen('liberadoEsteMes') }}</span>
        <span class="l">pagados este mes</span>
      </div>
      <div class="radm-num warn">
        <span class="n">{{ totalResumen('retenido') }}</span>
        <span class="l">retenidos</span>
        <span class="h">deuda si esos invitados cargan</span>
      </div>
      <div class="radm-num">
        <span class="n">{{ totalResumen('liberado') }}</span>
        <span class="l">pagados en total</span>
      </div>
      <div class="radm-num">
        <span class="n">{{ resumen.conversion.porcentaje }}<small>%</small></span>
        <span class="l">de los invitados cargó</span>
        <span class="h">{{ resumen.conversion.conFondeo }} de {{ resumen.conversion.vinculados }}</span>
      </div>
    </div>

    <div class="radm-estados">
      <span><b>{{ vinculados }}</b> vinculados</span>
      <span><b>{{ esperandoAlta }}</b> registros sin terminar</span>
      <span><b>{{ anulados }}</b> anulados</span>
      <span><b>{{ resumen.bonos.liberados }}</b> bonos cobrados</span>
      <span><b>{{ resumen.bonos.retenidos }}</b> bonos retenidos</span>
    </div>

    <!-- Pestañas -->
    <div class="radm-tabs">
      <button [class.on]="vista === 'inversion'" (click)="verVista('inversion')">Inversión y retorno</button>
      <button [class.on]="vista === 'campanas'" (click)="verVista('campanas')">Campañas</button>
      <button [class.on]="vista === 'vinculos'" (click)="verVista('vinculos')">Vínculos</button>
      <button [class.on]="vista === 'usuarios'" (click)="verVista('usuarios')">Registrados con llave</button>
      <button [class.on]="vista === 'ganancias'" (click)="verVista('ganancias')">Ganancias</button>
      <button [class.on]="vista === 'top'" (click)="verVista('top')">Rendimiento</button>
    </div>

    <!-- ========================================= Inversión y retorno ====== -->
    <div *ngIf="vista === 'inversion'">
      <ng-container *ngIf="inversion">
        <!-- El total del programa. Va arriba y aparte del listado porque sumar
             las páginas de una tabla paginada da el total de la página. -->
        <div class="radm-nums">
          <div class="radm-num" *ngFor="let i of inversion.totales.inversion">
            <span class="n">{{ i.pagado | number: '1.0-2' }}</span>
            <span class="l">{{ i.moneda }} pagados</span>
            <span class="h">{{ i.campanas }} campaña(s)</span>
          </div>
          <div class="radm-num warn" *ngFor="let i of inversion.totales.inversion">
            <span class="n">{{ i.comprometidoVivo | number: '1.0-2' }}</span>
            <span class="l">{{ i.moneda }} por salir</span>
            <span class="h">si los retenidos cumplen</span>
          </div>
          <div class="radm-num">
            <span class="n">{{ inversion.totales.activos }}</span>
            <span class="l">invitados que operaron</span>
            <span class="h">de {{ inversion.totales.invitados }} · {{ inversion.totales.operaciones }} operaciones</span>
          </div>
        </div>

        <div class="radm-estados">
          <span *ngFor="let v of inversion.totales.volumen">
            volumen <b>{{ v.monto | number: '1.0-0' }} {{ v.moneda }}</b>
          </span>
          <span *ngFor="let m of inversion.totales.margenEstimado">
            margen estimado <b>{{ m.monto | number: '1.0-0' }} {{ m.moneda }}</b>
          </span>
          <span *ngIf="inversion.totales.margenUsdMedible">
            medible en dólares <b>{{ inversion.totales.margenUsdMedible | number: '1.0-2' }} USD</b>
          </span>
        </div>

        <!-- Los supuestos van a la vista, no escondidos: un margen estimado que
             no dice que es estimado se lee como un dato duro. -->
        <p class="radm-nota">
          <b>Cómo leer esto.</b> La inversión y el volumen son exactos. El margen
          es una <b>estimación</b>: {{ inversion.supuestos.nota }}
          Se aplica
          <ng-container *ngFor="let m of inversion.supuestos.margenPorRiel; let i = index">
            <b>{{ m.pct }}%</b> a {{ m.destino }}<span *ngIf="i === 0"> y </span>
          </ng-container>.
          {{ inversion.supuestos.volumenNota }}
        </p>

        <div class="radm-filtros">
        <button class="radm-xls" [disabled]="descargando"
                (click)="descargarInversion()"
                title="Baja la tabla entera con los filtros puestos, no sólo esta página">
          {{ descargando === 'inversion' ? 'Bajando…' : 'Descargar XLS' }}
        </button>
        </div>

        <div class="radm-tabla-wrap">
          <p class="radm-vacio" *ngIf="cargandoTabla">Buscando…</p>
          <p class="radm-vacio" *ngIf="!cargandoTabla && !inversion.items.length">
            Todavía no hay campañas que medir.
          </p>

          <table *ngIf="!cargandoTabla && inversion.items.length">
            <thead>
              <tr>
                <th>Campaña</th>
                <th>Puesto</th>
                <th>Por salir</th>
                <th>Invitados</th>
                <th>Volumen que movieron</th>
                <th>Margen estimado</th>
                <th>Cobertura</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let f of inversion.items">
                <td>
                  <strong>{{ f.nombre }}</strong>
                  <span class="mono">{{ f.codigo }}</span>
                  <span class="pill mini">{{ f.estado }}</span>
                </td>
                <td>
                  {{ f.inversion.pagado | number: '1.0-2' }}
                  <span class="mono">{{ f.inversion.moneda }}</span>
                </td>
                <td>
                  {{ f.inversion.comprometidoVivo | number: '1.0-2' }}
                  <span class="dim small">de {{ f.inversion.presupuesto | number: '1.0-0' }} de bolsa</span>
                </td>
                <td>
                  {{ f.activos }} / {{ f.invitados }}
                  <span class="dim small">{{ f.operaciones }} operaciones</span>
                </td>
                <td>
                  <div *ngFor="let v of f.volumen">
                    {{ v.monto | number: '1.0-0' }} <span class="mono">{{ v.moneda }}</span>
                  </div>
                  <span class="dim small" *ngIf="!f.volumen.length">todavía no operaron</span>
                </td>
                <td>
                  <div *ngFor="let m of f.margenEstimado">
                    ~{{ m.monto | number: '1.0-0' }} <span class="mono">{{ m.moneda }}</span>
                  </div>
                  <span class="dim small" *ngIf="f.margenUsdMedible">
                    {{ f.margenUsdMedible | number: '1.0-2' }} USD medibles
                  </span>
                </td>
                <td>
                  <span class="pill ok" *ngIf="f.cobertura !== null && f.cobertura >= 100">
                    {{ f.cobertura }}%
                  </span>
                  <span class="pill wait" *ngIf="f.cobertura !== null && f.cobertura < 100">
                    {{ f.cobertura }}%
                  </span>
                  <span class="dim small" *ngIf="f.cobertura === null">{{ f.coberturaNota }}</span>
                </td>
              </tr>
            </tbody>
          </table>

          <div class="radm-paginado" *ngIf="inversion.total > limit">
            <button [disabled]="inversionPage <= 1" (click)="traerInversion(inversionPage - 1)">Anterior</button>
            <span>{{ inversionPage }} de {{ inversionPaginas }} &middot; {{ inversion.total }} campañas</span>
            <button [disabled]="inversionPage >= inversionPaginas" (click)="traerInversion(inversionPage + 1)">Siguiente</button>
          </div>
        </div>
      </ng-container>
    </div>

    <!-- ================================================== Ganancias ======= -->
    <div *ngIf="vista === 'ganancias'">
      <p class="radm-nota">
        Acá la fila es <b>una persona</b>, no un vínculo: suma lo que ganó por la
        gente que trajo y lo que le tocó por haberse registrado con la llave de
        alguien. Es la vista que contesta «¿cuánto tiene esta persona del
        programa?» sin cruzar dos tablas a mano.
      </p>

      <div class="radm-filtros">
        <input
          type="text"
          class="radm-buscar"
          [(ngModel)]="busquedaGanadores"
          (input)="onBuscarGanadores()"
          placeholder="Buscar por nombre, correo o usuario…"
        />
        <select [(ngModel)]="filtroGanancia" (change)="filtrarGanadores()">
          <option value="">Todos</option>
          <option value="COBRO">Cobraron algo</option>
          <option value="PENDIENTE">Tienen algo esperando</option>
          <option value="NADA">Ni cobraron ni esperan</option>
        </select>
        <button class="radm-xls" [disabled]="descargando"
                (click)="descargarGanancias()"
                title="Baja la tabla entera con los filtros puestos, no sólo esta página">
          {{ descargando === 'ganancias' ? 'Bajando…' : 'Descargar XLS' }}
        </button>
      </div>

      <div class="radm-tabla-wrap">
        <p class="radm-vacio" *ngIf="cargandoTabla">Buscando…</p>
        <p class="radm-vacio" *ngIf="!cargandoTabla && !ganadores.length">
          Nadie tiene bonos del programa todavía.
        </p>

        <table *ngIf="!cargandoTabla && ganadores.length">
          <thead>
            <tr>
              <th>Persona</th>
              <th>Papeles</th>
              <th>Cobró</th>
              <th>Espera</th>
              <th>Bonos</th>
              <th>Por qué espera</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let g of ganadores" [class.cobrado]="g.bonos.cobrados > 0">
              <td>
                <strong>{{ g.nombre }}</strong>
                <span class="mono" *ngIf="g.llave">&#64;{{ g.llave }}</span>
                <span class="dim small" *ngIf="g.email">{{ g.email }}</span>
              </td>
              <td>
                <span class="pill mini" *ngIf="g.comoReferidor">
                  invitó a {{ g.comoReferidor }}
                </span>
                <span class="pill mini" *ngIf="g.comoInvitado">fue invitado</span>
              </td>
              <td>
                <div *ngFor="let m of g.montos">
                  <span class="pill ok" *ngIf="m.cobrado > 0">
                    {{ m.cobrado | number: '1.0-2' }} {{ m.moneda }}
                  </span>
                </div>
              </td>
              <td>
                <div *ngFor="let m of g.montos">
                  <span class="pill" *ngIf="m.pendiente > 0">
                    {{ m.pendiente | number: '1.0-2' }} {{ m.moneda }}
                  </span>
                </div>
              </td>
              <td>
                {{ g.bonos.cobrados }} cobrados
                <span class="dim small">
                  {{ g.bonos.pendientes }} esperando &middot; {{ g.bonos.perdidos }} perdidos
                </span>
              </td>
              <td class="dim small">{{ motivoLegible(g.motivoPendiente) }}</td>
            </tr>
          </tbody>
        </table>

        <div class="radm-paginado" *ngIf="ganadoresTotal > limit">
          <button [disabled]="ganadoresPage <= 1" (click)="traerGanadores(ganadoresPage - 1)">Anterior</button>
          <span>{{ ganadoresPage }} de {{ ganadoresPaginas }} &middot; {{ ganadoresTotal }} personas</span>
          <button [disabled]="ganadoresPage >= ganadoresPaginas" (click)="traerGanadores(ganadoresPage + 1)">Siguiente</button>
        </div>
      </div>
    </div>

    <!-- ================================================== Campañas ======== -->
    <div *ngIf="vista === 'campanas'">
      <div class="radm-filtros">
        <select [(ngModel)]="filtroCampanaEstado" (change)="filtrarCampanas()">
          <option value="">Todos los estados</option>
          <option value="ACTIVA">Activas</option>
          <option value="PAUSADA">Pausadas</option>
          <option value="PROGRAMADA">Programadas</option>
          <option value="BORRADOR">Borradores</option>
          <option value="CERRADA">Cerradas</option>
        </select>
        <select [(ngModel)]="filtroCampanaTipo" (change)="filtrarCampanas()">
          <option value="">Todos los tipos</option>
          <option value="GLOBAL">Global</option>
          <option value="ASIGNADA">Asignadas</option>
        </select>
        <button class="radm-xls" [disabled]="descargando"
                (click)="descargarCampanas()"
                title="Baja la tabla entera con los filtros puestos, no sólo esta página">
          {{ descargando === 'campanas' ? 'Bajando…' : 'Descargar XLS' }}
        </button>
      </div>

      <div class="radm-tabla-wrap">
        <p class="radm-vacio" *ngIf="cargandoTabla">Buscando…</p>
        <p class="radm-vacio" *ngIf="!cargandoTabla && !campanas.length">
          Todavía no hay campañas. Con ninguna vigente, los vínculos se registran
          para medir el canal y no pagan nada.
        </p>

        <table *ngIf="!cargandoTabla && campanas.length">
          <thead>
            <tr>
              <th>Campaña</th>
              <th>Estado</th>
              <th>Alcance</th>
              <th>Bonos</th>
              <th>Cupos</th>
              <th>Bolsa</th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let c of campanas"
                [class.cobrado]="c.estado === 'ACTIVA'"
                [class.anulado]="c.estado === 'CERRADA'">
              <td>
                <strong>{{ c.nombre }}</strong>
                <span class="mono">{{ c.codigo }}</span>
                <span class="pill mini">{{ c.tipo === 'GLOBAL' ? 'global' : 'asignada' }}</span>
                <span class="dim small" *ngIf="c.tipo === 'ASIGNADA'">
                  {{ c.referidores }} referidor(es)
                </span>
              </td>
              <td>
                <span class="pill" [class.ok]="c.estado === 'ACTIVA'"
                      [class.bad]="c.estado === 'CERRADA'">{{ c.estado }}</span>
                <span class="dim small" *ngIf="c.pausadaMotivo === 'VELOCIDAD'">
                  la pausó el freno de velocidad
                </span>
              </td>
              <td>
                {{ c.alcanceCodigo }}
                <span class="dim small">{{ c.gatilloReferidor }}</span>
              </td>
              <td>
                {{ c.montoReferidor | number: '1.0-2' }} + {{ c.montoReferido | number: '1.0-2' }}
                <span class="mono">{{ c.moneda }}</span>
              </td>
              <td>
                {{ c.unidadesUsadas }} / {{ c.unidadesTotal }}
                <span class="dim small">{{ c.cupoRestante }} libres</span>
              </td>
              <td>
                {{ c.pagado | number: '1.0-2' }} pagado
                <span class="dim small">
                  {{ c.comprometido | number: '1.0-2' }} de {{ c.presupuesto | number: '1.0-2' }}
                </span>
              </td>
              <td class="radm-acciones">
                <button (click)="abrirCampana(c)">Ver</button>
                <button *ngIf="c.estado !== 'CERRADA'" (click)="abrirEdicion(c)">Editar</button>
                <!-- Deshabilitado, no escondido: el backend rechaza activar una
                     asignada sin nadie asignado, y esconder el botón dejaría al
                     operador buscando por qué no está. -->
                <button *ngIf="puede(c, 'activar')"
                        [disabled]="c.tipo === 'ASIGNADA' && !c.referidores"
                        [title]="c.tipo === 'ASIGNADA' && !c.referidores
                          ? 'Sin referidores asignados no engancha a nadie: abrí «Ver» y asigná al menos uno.'
                          : ''"
                        (click)="accion(c, 'activar')">Activar</button>
                <button *ngIf="puede(c, 'pausar')" (click)="accion(c, 'pausar')">Pausar</button>
                <button *ngIf="puede(c, 'reanudar')" (click)="accion(c, 'reanudar')">Reanudar</button>
                <button *ngIf="puede(c, 'cerrar')" (click)="accion(c, 'cerrar')">Cerrar</button>
                <!-- Siempre visible, también en las cerradas: es cuando más se
                     necesita saber qué pasó con lo que se pagó. -->
                <button [disabled]="!!descargando"
                        title="Quién cobró bono y qué hizo con la plata: cargas, conversiones, envíos y saldo hoy"
                        (click)="descargarLibroCampana(c)">
                  {{ descargando === 'libro-' + c.referidoCampanaId ? 'Bajando…' : 'XLS' }}
                </button>
              </td>
            </tr>
          </tbody>
        </table>

        <div class="radm-paginado" *ngIf="campanasTotal > limit">
          <button [disabled]="campanasPage <= 1" (click)="traerCampanas(campanasPage - 1)">Anterior</button>
          <span>{{ campanasPage }} de {{ campanasPaginas }} &middot; {{ campanasTotal }} campañas</span>
          <button [disabled]="campanasPage >= campanasPaginas" (click)="traerCampanas(campanasPage + 1)">Siguiente</button>
        </div>
      </div>

      <!-- Detalle: riesgo, fuga y retorno de una campaña -->
      <div class="radm-overlay" *ngIf="campanaAbierta" (click)="cerrarCampana()">
        <div class="radm-modal ancho" (click)="$event.stopPropagation()">
          <h2>{{ campanaAbierta.nombre }} <span class="mono">{{ campanaAbierta.codigo }}</span></h2>

          <p class="radm-vacio" *ngIf="cargandoTablero">Cargando el tablero…</p>

          <ng-container *ngIf="!cargandoTablero && tablero">
            <!-- Riesgo. El gasto del mes solo engaña: se ve bajo justo antes de
                 que una tanda de invitados fondee junta. -->
            <div class="radm-nums" *ngIf="tablero.riesgo">
              <div class="radm-num warn">
                <span class="n">{{ tablero.riesgo.enRiesgo | number: '1.0-2' }}</span>
                <span class="l">{{ tablero.riesgo.moneda }} en riesgo</span>
                <span class="h">se pagan si los retenidos cumplen</span>
              </div>
              <div class="radm-num">
                <span class="n">{{ tablero.riesgo.pagado | number: '1.0-2' }}</span>
                <span class="l">{{ tablero.riesgo.moneda }} ya pagados</span>
              </div>
              <div class="radm-num">
                <span class="n">{{ tablero.riesgo.bolsaLibre | number: '1.0-2' }}</span>
                <span class="l">{{ tablero.riesgo.moneda }} libres</span>
                <span class="h">para prometerle a alguien más</span>
              </div>
              <div class="radm-num">
                <span class="n">{{ tablero.riesgo.cupos.restantes }}</span>
                <span class="l">cupos libres</span>
                <span class="h">de {{ tablero.riesgo.cupos.total }}</span>
              </div>
            </div>

            <!-- Retorno vs mínimo de recarga -->
            <h3>Retorno</h3>
            <div class="radm-estados">
              <span>
                <b>{{ tablero.retorno.volumenNecesarioUsd | number: '1.0-0' }} USD</b>
                de volumen para recuperar lo pagado
              </span>
              <span><b>{{ tablero.retorno.invitadosQueCargaron }}</b> cargaron</span>
              <span><b>{{ tablero.retorno.invitadosQueOperaron }}</b> además operaron</span>
              <span><b>{{ tablero.retorno.conversionAOperar }}%</b> pasa de cargar a operar</span>
            </div>
            <p class="radm-aviso" *ngIf="tablero.retorno.minimoYSeFueron > 0">
              <b>{{ tablero.retorno.minimoYSeFueron }}</b> cargaron pegados al mínimo y
              nunca operaron ({{ tablero.retorno.pegadosAlMinimoPct }}% cargó cerca del piso).
              Ése es el que cuesta plata: cobró el bono, dejó el piso adentro y se fue.
            </p>
            <p class="radm-nota">
              El volumen necesario es una <b>estimación</b> con el margen del riel
              ({{ tablero.retorno.volumenPorUnidadUsd }} USD por cada unidad de bono),
              no una medición: el margen real por operación no está en la base.
            </p>

            <!-- Fuga: por qué no cobra la gente -->
            <h3>Por qué no cobran</h3>
            <p class="radm-nota">
              <b>{{ tablero.fuga.esperando.lados }}</b> lados todavía pueden destrabarse
              &middot; <b>{{ tablero.fuga.fugados.lados }}</b> ya no van a cambiar solos.
            </p>
            <table *ngIf="tablero.fuga.items.length">
              <thead>
                <tr><th>Motivo</th><th>Lado</th><th>Casos</th><th>Monto</th></tr>
              </thead>
              <tbody>
                <tr *ngFor="let f of tablero.fuga.items" [class.anulado]="f.terminal">
                  <td>
                    {{ motivoLegible(f.motivo) }}
                    <span class="pill mini bad" *ngIf="f.terminal">no se destraba</span>
                  </td>
                  <td class="dim">{{ f.lado === 'referidor' ? 'quien invitó' : 'invitado' }}</td>
                  <td>{{ f.total }}</td>
                  <td>{{ f.monto | number: '1.0-2' }} {{ f.moneda || '' }}</td>
                </tr>
              </tbody>
            </table>
            <p class="radm-vacio" *ngIf="!tablero.fuga.items.length">
              Nadie está esperando: todos los bonos de esta campaña se resolvieron.
            </p>
          </ng-container>

          <!-- Si el tablero fallaba, el panel se quedaba en blanco y con él
               desaparecía el botón de asignar: el operador se quedaba sin poder
               armar la lista de una campaña por culpa de unos números. -->
          <p class="radm-aviso" *ngIf="!cargandoTablero && !tablero">
            No se pudo traer el tablero de esta campaña. Las asignaciones de
            abajo siguen andando.
          </p>

          <!-- Referidores asignados. Va fuera del tablero a propósito: es la
               única acción del panel, y sin ella una campaña asignada no
               engancha a nadie. -->
          <ng-container *ngIf="campanaAbierta.tipo === 'ASIGNADA'">
            <h3>
              Quiénes tienen el link mejorado
              <span>
                <button class="radm-config-btn" (click)="abrirAsignar()">Asignar</button>
                <button class="radm-xls" [disabled]="descargando"
                        (click)="descargarAsignaciones()"
                        title="Baja la tabla entera con los filtros puestos, no sólo esta página">
                  {{ descargando === 'asignaciones' ? 'Bajando…' : 'XLS' }}
                </button>
              </span>
            </h3>
            <p class="radm-vacio" *ngIf="!asignaciones.length">
              Todavía no hay nadie asignado: sin referidores, esta campaña no
              engancha a nadie y sus links caen a la global.
            </p>
            <table *ngIf="asignaciones.length">
              <thead>
                <tr>
                  <th>Referidor</th><th>Cuota</th><th>Invitados</th>
                  <th>Cargaron</th><th>Asignó</th><th></th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let a of asignaciones" [class.anulado]="!a.activa">
                  <td>
                    <strong>{{ a.nombre }}</strong>
                    <span class="mono" *ngIf="a.llave">&#64;{{ a.llave }}</span>
                    <span class="pill mini" *ngIf="!a.activa">desasignado</span>
                  </td>
                  <td>
                    {{ a.cuotaUsada }} / {{ a.cuota || campanaAbierta.cuotaPorReferidor || '&#8734;' }}
                  </td>
                  <td>{{ a.invitados }}</td>
                  <td>{{ a.conFondeo }}</td>
                  <td class="dim small">{{ a.asignadaPorEmail }}</td>
                  <td>
                    <button *ngIf="a.activa" (click)="desasignar(a)">Sacar</button>
                  </td>
                </tr>
              </tbody>
            </table>

            <div class="radm-paginado" *ngIf="asignacionesTotal > limit">
              <button [disabled]="asignacionesPage <= 1"
                      (click)="irAPaginaAsignaciones(asignacionesPage - 1)">Anterior</button>
              <span>{{ asignacionesPage }} &middot; {{ asignacionesTotal }} referidores</span>
              <button (click)="irAPaginaAsignaciones(asignacionesPage + 1)">Siguiente</button>
            </div>
          </ng-container>

          <div class="radm-modal-acciones">
            <button class="radm-btn-cancelar" (click)="cerrarCampana()">Cerrar</button>
          </div>
        </div>
      </div>
    </div>

    <!-- ================================================== Vínculos ======== -->
    <div *ngIf="vista === 'vinculos'">
      <!-- Filtros: sin esto la tabla es inservible pasados unos cientos de
           vínculos, que es cuando aparece la pregunta "¿este cliente cobró?" -->
      <div class="radm-filtros">
        <input
          type="text"
          class="radm-buscar"
          [(ngModel)]="busqueda"
          (input)="onBuscar()"
          placeholder="Buscar por nombre, correo o usuario…"
        />

        <select [(ngModel)]="filtroBono" (change)="aplicarFiltros()">
          <option value="">Todos los bonos</option>
          <option value="PENDIENTE">Con bono pendiente</option>
          <option value="COBRADO">Ya cobrados</option>
        </select>

        <select [(ngModel)]="filtroEstado" (change)="aplicarFiltros()">
          <option value="">Todos los estados</option>
          <option value="VINCULADO">Vinculados</option>
          <option value="ESPERANDO_ALTA">Registro sin terminar</option>
          <option value="ANULADO">Anulados</option>
        </select>

        <button class="radm-limpiar" *ngIf="hayFiltros" (click)="limpiarFiltros()">
          Limpiar
        </button>
        <button class="radm-xls" [disabled]="descargando"
                (click)="descargarVinculos()"
                title="Baja la tabla entera con los filtros puestos, no sólo esta página">
          {{ descargando === 'vinculos' ? 'Bajando…' : 'Descargar XLS' }}
        </button>
      </div>

      <div class="radm-tabla-wrap">
        <p class="radm-vacio" *ngIf="cargandoTabla">Buscando…</p>

        <p class="radm-vacio" *ngIf="!cargandoTabla && !bonos.length && hayFiltros">
          Ningún vínculo coincide con ese filtro.
        </p>
        <p class="radm-vacio" *ngIf="!cargandoTabla && !bonos.length && !hayFiltros">
          Todavía no hay vínculos registrados.
        </p>

        <table *ngIf="!cargandoTabla && bonos.length">
          <thead>
            <tr>
              <th>Invitó</th>
              <th>Invitado</th>
              <th>Fondeo</th>
              <th>Bono de quien invitó</th>
              <th>Bono del invitado</th>
              <th>Registrado</th>
            </tr>
          </thead>
          <tbody>
            <tr
              *ngFor="let b of bonos"
              [class.anulado]="b.estado === 'ANULADO'"
              [class.cobrado]="cobrado(b)"
            >
              <td>
                <strong>{{ b.referidor.nombre }}</strong>
                <span class="mono">&#64;{{ b.llaveReferidor }}</span>
                <span class="dim small" *ngIf="b.referidor.email">{{ b.referidor.email }}</span>
              </td>
              <td>
                <strong>{{ b.invitado.nombre }}</strong>
                <span class="dim small" *ngIf="b.invitado.email">{{ b.invitado.email }}</span>
                <span class="pill mini" *ngIf="b.estado === 'ESPERANDO_ALTA'">sin terminar</span>
                <span class="pill mini bad" *ngIf="b.estado === 'ANULADO'">anulado</span>
              </td>
              <td>
                <ng-container *ngIf="b.fondeo">
                  {{ b.fondeo.fecha | date: 'dd/MM/yy' }}
                  <span class="mono">{{ b.fondeo.moneda }}</span>
                </ng-container>
                <span class="pill" *ngIf="!b.fondeo">sin cargar</span>
              </td>
              <td>
                <span class="pill ok" *ngIf="b.bonoReferidor.estado === 'LIBERADO'">
                  cobr&oacute; {{ b.bonoReferidor.montoUsdt | number: '1.0-2' }} {{ b.bonoReferidor.moneda || 'USDT' }}
                </span>
                <span class="dim small" *ngIf="b.bonoReferidor.liberadoAt">
                  {{ b.bonoReferidor.liberadoAt | date: 'dd/MM/yy' }}
                </span>
                <span class="pill" *ngIf="b.bonoReferidor.estado !== 'LIBERADO'">
                  retenido {{ b.bonoReferidor.montoUsdt | number: '1.0-2' }}
                </span>
              </td>
              <td>
                <span class="pill ok" *ngIf="b.bonoReferido.estado === 'LIBERADO'">
                  cobr&oacute; {{ b.bonoReferido.montoUsdt | number: '1.0-2' }} {{ b.bonoReferido.moneda || 'USDT' }}
                </span>
                <span class="dim small" *ngIf="b.bonoReferido.liberadoAt">
                  {{ b.bonoReferido.liberadoAt | date: 'dd/MM/yy' }}
                </span>
                <span class="pill" *ngIf="b.bonoReferido.estado !== 'LIBERADO'">
                  retenido {{ b.bonoReferido.montoUsdt | number: '1.0-2' }}
                </span>
              </td>
              <td class="dim">{{ b.createdAt | date: 'dd/MM/yy' }}</td>
            </tr>
          </tbody>
        </table>

        <div class="radm-paginado" *ngIf="total > limit">
          <button [disabled]="page <= 1" (click)="irAPagina(page - 1)">Anterior</button>
          <span>{{ page }} de {{ totalPaginas }} &middot; {{ total }} v&iacute;nculos</span>
          <button [disabled]="page >= totalPaginas" (click)="irAPagina(page + 1)">Siguiente</button>
        </div>
      </div>
    </div>

    <!-- ======================================== Registrados con llave ===== -->
    <div *ngIf="vista === 'usuarios'">
      <p class="radm-nota">
        Todos los que entraron por el link de alguien, incluidos los que no
        terminaron el registro &mdash; son los que más preguntan.
      </p>

      <div class="radm-filtros">
        <input
          type="text"
          class="radm-buscar"
          [(ngModel)]="busquedaUsuarios"
          (input)="onBuscarUsuarios()"
          placeholder="Buscar por nombre, correo o usuario…"
        />
        <select [(ngModel)]="filtroReclamo" (change)="filtrarUsuarios()">
          <option value="">Todos</option>
          <option value="COBRO">Ya cobraron</option>
          <option value="PENDIENTE">Esperando</option>
          <option value="SIN_BONO">Sin bono</option>
        </select>
        <button class="radm-xls" [disabled]="descargando"
                (click)="descargarUsuariosConLlave()"
                title="Baja la tabla entera con los filtros puestos, no sólo esta página">
          {{ descargando === 'registrados' ? 'Bajando…' : 'Descargar XLS' }}
        </button>
      </div>

      <div class="radm-tabla-wrap">
        <p class="radm-vacio" *ngIf="cargandoTabla">Buscando…</p>
        <p class="radm-vacio" *ngIf="!cargandoTabla && !usuarios.length">
          Nadie se registró con una llave todavía.
        </p>

        <table *ngIf="!cargandoTabla && usuarios.length">
          <thead>
            <tr>
              <th>Registrado</th>
              <th>Lo invitó</th>
              <th>Campaña</th>
              <th>Cargó</th>
              <th>Su bono</th>
              <th>Fecha</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let u of usuarios"
                [class.cobrado]="u.bonoInvitado.estado === 'LIBERADO'"
                [class.anulado]="u.estado === 'ESPERANDO_ALTA'">
              <td>
                <strong>{{ u.invitado.nombre }}</strong>
                <span class="dim small" *ngIf="u.invitado.email">{{ u.invitado.email }}</span>
                <span class="mono" *ngIf="u.invitado.llave">&#64;{{ u.invitado.llave }}</span>
                <span class="pill mini bad" *ngIf="u.invitado.usuarioId && !u.invitado.complianceAprobado">
                  sin aprobar
                </span>
              </td>
              <td>
                {{ u.referidor.nombre }}
                <span class="mono">&#64;{{ u.referidor.llave }}</span>
              </td>
              <td>
                <ng-container *ngIf="u.campana">
                  <span class="mono">{{ u.campana.codigo }}</span>
                  <span class="pill mini">{{ u.campana.tipo === 'GLOBAL' ? 'global' : 'asignada' }}</span>
                </ng-container>
                <span class="pill mini bad" *ngIf="!u.campana">sin campaña</span>
              </td>
              <td>
                <ng-container *ngIf="u.fondeo">
                  {{ u.fondeo.monto | number: '1.0-2' }}
                  <span class="mono">{{ u.fondeo.moneda }}</span>
                  <span class="dim small">{{ u.fondeo.fecha | date: 'dd/MM/yy' }}</span>
                </ng-container>
                <span class="pill" *ngIf="!u.fondeo">sin cargar</span>
              </td>
              <td>
                <span class="pill ok" *ngIf="u.bonoInvitado.estado === 'LIBERADO'">
                  cobr&oacute; {{ u.bonoInvitado.monto | number: '1.0-2' }} {{ u.bonoInvitado.moneda }}
                </span>
                <ng-container *ngIf="u.bonoInvitado.estado !== 'LIBERADO'">
                  <span class="pill">{{ u.bonoInvitado.estado | lowercase }}</span>
                  <span class="dim small">{{ motivoLegible(u.bonoInvitado.motivo) }}</span>
                </ng-container>
              </td>
              <td class="dim">{{ u.registradoAt | date: 'dd/MM/yy' }}</td>
            </tr>
          </tbody>
        </table>

        <div class="radm-paginado" *ngIf="usuariosTotal > limit">
          <button [disabled]="usuariosPage <= 1" (click)="traerUsuarios(usuariosPage - 1)">Anterior</button>
          <span>{{ usuariosPage }} de {{ usuariosPaginas }} &middot; {{ usuariosTotal }} registrados</span>
          <button [disabled]="usuariosPage >= usuariosPaginas" (click)="traerUsuarios(usuariosPage + 1)">Siguiente</button>
        </div>
      </div>
    </div>

    <!-- ================================================ Rendimiento ======= -->
    <div *ngIf="vista === 'top'">
      <h3>
        Qué rindió cada campaña
        <button class="radm-xls" [disabled]="descargando"
                (click)="descargarRendimiento()"
                title="Baja la tabla entera con los filtros puestos, no sólo esta página">
          {{ descargando === 'rendimiento' ? 'Bajando…' : 'Descargar XLS' }}
        </button>
      </h3>
      <div class="radm-tabla-wrap">
        <p class="radm-vacio" *ngIf="!rendimiento.length">Todavía no hay campañas con datos.</p>
        <table *ngIf="rendimiento.length">
          <thead>
            <tr>
              <th>Campaña</th><th>Referidores</th><th>Invitados</th>
              <th>Cargaron</th><th>Conversión</th><th>Pagado</th><th>Costo por activo</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let r of rendimiento">
              <td>
                <strong>{{ r.nombre }}</strong>
                <span class="mono">{{ r.codigo }}</span>
                <span class="pill mini">{{ r.estado }}</span>
                <span class="pill mini" *ngIf="r.alcance">{{ r.alcance }}</span>
              </td>
              <td>{{ r.referidores }}</td>
              <td>{{ r.invitados }}</td>
              <td>{{ r.conFondeo }}</td>
              <td>{{ r.conversion }}%</td>
              <td>{{ r.pagado | number: '1.0-2' }} {{ r.moneda }}</td>
              <td>
                <ng-container *ngIf="r.costoPorActivo !== null">
                  {{ r.costoPorActivo | number: '1.0-2' }} {{ r.moneda }}
                </ng-container>
                <span class="dim" *ngIf="r.costoPorActivo === null">todavía no se sabe</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <h3>
        Quiénes traen más gente
        <button class="radm-xls" [disabled]="descargando"
                (click)="descargarReferidores()"
                title="Baja la tabla entera con los filtros puestos, no sólo esta página">
          {{ descargando === 'referidores' ? 'Bajando…' : 'Descargar XLS' }}
        </button>
      </h3>
      <div class="radm-tabla-wrap">
        <p class="radm-vacio" *ngIf="!top.length">Todavía nadie trajo invitados.</p>

        <table *ngIf="top.length">
          <thead>
            <tr>
              <th>Usuario</th>
              <th>Invitados</th>
              <th>Cargaron</th>
              <th>Bonos</th>
              <th>Cobró</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let r of top" [class.sospechoso]="esSospechoso(r)">
              <td>
                {{ r.nombre || '&#8212;' }}
                <span class="mono" *ngIf="r.llave">&#64;{{ r.llave }}</span>
              </td>
              <td>{{ r.invitados }}</td>
              <td>
                {{ r.conFondeo }}
                <span class="pill mini bad" *ngIf="esSospechoso(r)">ninguno fondeó</span>
              </td>
              <td>{{ r.bonosCobrados }}</td>
              <td>{{ r.cobradoUsdt | number: '1.0-2' }} {{ r.moneda || 'USDT' }}</td>
            </tr>
          </tbody>
        </table>

        <div class="radm-paginado" *ngIf="topTotal > limit">
          <button [disabled]="topPage <= 1" (click)="traerTop(topPage - 1)">Anterior</button>
          <span>{{ topPage }} de {{ topPaginas }} &middot; {{ topTotal }} referidores</span>
          <button [disabled]="topPage >= topPaginas" (click)="traerTop(topPage + 1)">Siguiente</button>
        </div>
      </div>
    </div>
  </ng-container>
</div>
